import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    get() {
        return http.get(buildUrlFromLocation("/displayers/types"));
    }
};



// WEBPACK FOOTER //
// ./src/services/displayerType.js